import { getApiProfile } from "./getApiProfile";
import { getApiProfilePrimary } from "./getApiProfilePrimary";
import { putApiProfile } from "./putApiProfile";

export function profileController() {
  return { putApiProfile, getApiProfile, getApiProfilePrimary };
}
